<template>
  <div ref="allShipments">
    <slot v-for="(shipment, index) in shipments" :key="index" :index="index" :shipment="shipment" :last-index="index === shipments.length - 1"></slot>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  shipments: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  nextOffset: {
    type: Number,
    required: false,
    default: 0,
  },
});
const emit = defineEmits(['load']);
const allShipments = ref(null);
const scrollHandler = () => {
  if (props.loading || !props.nextOffset || !allShipments.value) return;
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
  const container = allShipments.value;
  const lastShipment = container.lastElementChild;
  if (!lastShipment) return;
  const endOfList = container.offsetTop + (container.offsetHeight - lastShipment.offsetHeight);
  if (windowHeight + scrollTop >= endOfList) {
    emit('load');
  }
};
onMounted(() => {
  window.addEventListener('scroll', scrollHandler);
});
onUnmounted(() => {
  window.removeEventListener('scroll', scrollHandler);
});
</script>
